import React from 'react';
import { Renamer, RenamerProps } from './renamer';
import styles from './new-file-namer.module.css';

export function NewFileNamer(props: RenamerProps) {
	return (
		<div className={styles.newFileNamer}>
			<i className="playcon-text" />
			<Renamer {...props} />
		</div>
	);
}
